import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSocketEvent } from '../../../core/shared/hooks/useSocket.js';

/**
 * Listens for Socket.io events that affect dashboard data and auto-invalidates queries.
 * Call this hook once at the dashboard layout level.
 */
export function useDashboardSocket() {
  const queryClient = useQueryClient();

  const handleDashboardUpdate = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['dashboard'] });
  }, [queryClient]);

  const handleWinkelUpdate = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['winkel-dashboard'] });
  }, [queryClient]);

  const handleAlertUpdate = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['dashboard', 'alerts'] });
  }, [queryClient]);

  // Smart import completed → refresh all dashboard data
  useSocketEvent('dashboard:import_complete', handleDashboardUpdate);

  // Alert generated → refresh alerts
  useSocketEvent('dashboard:alert_generated', handleAlertUpdate);

  // Dossier status change → refresh winkel dashboard
  useSocketEvent('dossier:status_changed', handleWinkelUpdate);
  useSocketEvent('dossier:updated', handleWinkelUpdate);

  // Databus events from WMS
  useSocketEvent('databus.goederen_gescand', handleWinkelUpdate);
  useSocketEvent('databus.levering_voltooid', handleWinkelUpdate);

  // Logistiek updates
  useSocketEvent('logistiek:update', handleWinkelUpdate);
}
